<template>
<v-row>
  <v-col cols=12 >
    <slot name='about' ></slot>
  </v-col>
  <v-col cols=12 sm='8' class='text-center pl-5' >
    <div class='grey lighten-2 elevation-10' >
      <slot name='iframe-toolbar' ></slot>

      <v-progress-linear indeterminate v-if='loading' class='ma-0 pa-0' height='2' />

      <div >
        <iframe
          v-if='src'
          v-show='visible'
          :src='src'
          :width='width'
          :id='iframeName'
          :name='iframeName'
          @load='$emit("iframe:loaded")'
          height='800px' class='elevation-10 ma-0 pa-0'
          frameborder='0' loading='lazy' />
        <slot v-else name='empty-text' ></slot>
        <slot name='alternative-view' ></slot>
      </div>
    </div>
  </v-col>
  <v-col cols='12' sm=4 class='pr-5' >
    <v-card outlined >
      <slot name='preferences' ></slot>
    </v-card>
  </v-col>
</v-row>
</template>
<script>
import {DEFAULT_MOBILE_PHONE_WIDTH} from '@/store/constants.js'

export default {
  name: 'IframeTemplate',
  props: {
    src: { required: false },
    width: { default: DEFAULT_MOBILE_PHONE_WIDTH },
    height: { default: '1024px' },
    loading: { type: Boolean, default: false },
    visible: { type: Boolean, default: true },
    iframeName: { type: String, requied: false }
  }
}
</script>
